import { AbstractControl, ValidatorFn } from '@angular/forms';

export const requireReviewTagsValidator = (minStarsRequiredWithoutTags: number, selectedTagsResolver: () => string[], shouldValidate: () => boolean): ValidatorFn => {
  return (control: AbstractControl) => {
    if (! shouldValidate()) {
      return null;
    }

    const value = control.value;

    if (! value) {
      return {
        required: true,
      }
    }

    if (value < minStarsRequiredWithoutTags && selectedTagsResolver().length === 0) {
      return {
        categoryTagsRequired: true,
      }
    }

    return null;
  };
}
